// extracted by mini-css-extract-plugin
module.exports = {"container":"playlist_container_1UAdT","content":"playlist_content_vi1zd","details":"playlist_details_3L_uJ","title":"playlist_title_2G7tq"};